'use client'

import { cn } from '~/lib/utils'

interface SpinnerProps {
  className?: string
}

export function Spinner({ className }: SpinnerProps) {
  return (
    <div className={cn('relative size-5', className)}>
      <div className="absolute size-full animate-spin rounded-full shadow-[0_2px_0_0] ">
        <div className="size-full rounded-full" />
      </div>
    </div>
  )
}
